import React from "react";

import { camelCase } from "./stringUtilHelper";
import Templates from "../templates/simpleTemplates";

const mapContentItem = (item) => {
  let output = ("");

  if (item?.internal?.type) {
    const type = camelCase(item.internal.type);
    const TagName = Templates[`${type.charAt(0).toUpperCase()}${type.slice(1)}`];
    let extra = null;

    if (!TagName) return (<div className="alert alert-warning">## missing element ##</div>);

    switch (item.internal.type) {
      case "kontent_item_image":
        extra = {
          enableComponentStyle: true,
        };
        break;
      default:
        extra = null;
    }

    try {
      output = (<TagName data={item} {...extra} />);
    } catch (e) {
      output = ("Error");
    }
  }

  return output;
};

export default mapContentItem;
